import React from 'react';
import { Plus } from 'react-feather';
import { Link } from 'react-router-dom';

const AddButton = ({ route, text = 'Add' }) => {
  return (
    <Link
      className="text-sm text-primary flex items-center cursor-pointer"
      to={route}
    >
      <Plus className="mr-1" style={{width: '18px'}}/>
      <p>{text}</p>
    </Link>
  )
}

export { AddButton }
